import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { PureComponent } from 'react';
import { Paragraph } from '../../typography';

var FormFieldHint =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FormFieldHint, _PureComponent);

  function FormFieldHint() {
    _classCallCheck(this, FormFieldHint);

    return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldHint).apply(this, arguments));
  }

  _createClass(FormFieldHint, [{
    key: "render",
    value: function render() {
      return React.createElement(Paragraph, _extends({
        marginTop: 0,
        size: 300,
        color: "muted"
      }, this.props));
    }
  }]);

  return FormFieldHint;
}(PureComponent);

FormFieldHint.displayName = "FormFieldHint";

_defineProperty(FormFieldHint, "propTypes", _objectSpread({}, Paragraph.propTypes));

export { FormFieldHint as default };